export const version = '20221214';


// WEBPACK FOOTER //
// ./src/config/version.js